import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

const Auction = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <Link
                        className="nav-link active1 fontSizeClass"
                        to="/Auction"
                      >
                        {t("Auction")}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("List Of Auctions")} </h3>
                  </div>
                  <div className="mayor-table2">
                    <table className="table table-bordered">
                      <tbody>
                        <tr className="table-warning table-bor-2">
                          <td>{t("Auction")}</td>
                          <td>{t("Auction Uploaded On")}</td>
                          <td>{t("Action")}</td>
                        </tr>
                        <tr>
                          <td>
                            Allotment of fee car parking spaces within the
                            jurisdiction of the KMC area (Day time: 7:00 am to
                            10:00 pm) as per lot description given below, for
                            realization of parking fees from parked vehicles
                            against payment of license fees to KMC for a period
                            of two (02) months. The period may be further
                            extended upon application for one (01) month at a
                            time thereafter on mutual consent, effective from
                            the date of issuance of the work order.
                          </td>
                          <td>23/09/2025</td>
                          <td>
                            <DownloadFileByFileStoreId
                              fileStoreId={
                                "34ce0eae-5dd4-4aab-8f25-01a2ebc7388d"
                              }
                              label="Download"
                            />
                            {/* <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'34ce0eae-5dd4-4aab-8f25-01a2ebc7388d'}&tenantId=km.kolkata`}>  {t("Download")} </a>  */}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Auction;
